import { default as GameNavigationAlias } from 'chi-helpers/game-navigation';

export default GameNavigationAlias.GameNavigation;